module.exports = __webpack_public_path__ + "images/overweight.b62a48ae25e269a2fdf834dbe38cc206.png";